import { t } from "ttag";

import { KlarnaLogo } from "@/assets";
import type { Invoice } from "@/shared/domains";
import { PAYMENT_METHOD_TYPE } from "@/shared/domains";

interface PaymentMethodDisplayProps {
  paymentMethod: Invoice["paymentMethod"];
  compact?: boolean;
}

export const PaymentMethodDisplay = ({
  paymentMethod,
  compact = false,
}: PaymentMethodDisplayProps) => {
  if (
    paymentMethod?.type === PAYMENT_METHOD_TYPE.CARD ||
    paymentMethod?.type === PAYMENT_METHOD_TYPE.APPLE_PAY
  ) {
    const mask = compact ? "****" : "**** **** ****";

    return (
      <span>
        {mask} {paymentMethod.metadata.lastFourDigits}
      </span>
    );
  }

  if (paymentMethod?.type === PAYMENT_METHOD_TYPE.KLARNA) {
    return <img src={KlarnaLogo} alt={t`Klarna logo`} className="h-7" />;
  }

  return t`N/A`;
};
